/**
 * Archimedean spiral formation slots around path centroid.
 * Units occupy slots by index; outer ring for new units; edge dies first on loss.
 */
import { SPIRAL_A, SPIRAL_ANGLE_STEP, SPIRAL_B } from "./constants.js";
/**
 * Slot i on an Archimedean spiral: r = a + b * θ, θ = i * step.
 * Index 0 sits near the centroid (small radius).
 */
export function spiralSlot(index) {
    const i = Math.max(0, Math.floor(index));
    const angle = i * SPIRAL_ANGLE_STEP;
    const radius = SPIRAL_A + SPIRAL_B * angle;
    const x = radius * Math.cos(angle);
    const z = radius * Math.sin(angle);
    return { index: i, radius, angle, x, z };
}
/** Generate N formation slots (indices 0..N-1). */
export function formationSlots(n) {
    const count = Math.max(0, Math.floor(n));
    const slots = new Array(count);
    for (let i = 0; i < count; i++) {
        slots[i] = spiralSlot(i);
    }
    return slots;
}
/**
 * World-space positions: centroid at (cx, cz), slots offset in XZ plane.
 * Path forward is +Z; lateral is X.
 */
export function slotsWorld(n, centroidX, centroidZ) {
    return formationSlots(n).map((s) => ({
        ...s,
        wx: centroidX + s.x,
        wz: centroidZ + s.z,
    }));
}
/**
 * On unit loss, edge (highest index) dies first — so we simply shrink N
 * and recompute slots 0..N-1. On gain, new units take outer indices.
 */
export function slotCountForN(n) {
    return Math.max(0, Math.floor(n));
}
//# sourceMappingURL=formation.js.map